import * as tslib_1 from "tslib";
import { ElementRef, OnDestroy, OnInit, Renderer, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { filter, map, tap } from 'rxjs/operators';
import { SimpleMdPipe } from 'src/app/simple-md.pipe';
import { environment } from 'src/environments/environment';
import { FacebookPixelEventTrackerService } from '../facebook-pixel-event-tracker.service';
import { setCurrentCourse, setCurrentLesson } from '../state/courses/actions';
import { selectCurrentCourse, selectCurrentLesson } from '../state/courses/selectors';
import * as ui from '../state/ui';
import { VideoComponent } from '../videoComponent';
var tourKey = 'guided-tour-has-run';
var curTourDate = '2019-11-05';
var CourseComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CourseComponent, _super);
    function CourseComponent(route, store, facebookPixelEventTracker, meta, titleService, renderer, renderer2) {
        var _this = _super.call(this, store, facebookPixelEventTracker) || this;
        _this.route = route;
        _this.meta = meta;
        _this.titleService = titleService;
        _this.renderer = renderer;
        _this.renderer2 = renderer2;
        _this.hideTrailerOverlay = false;
        _this.tourHasRun = false;
        _this.tourIsOpen = false;
        _this.donationUrl = environment.defaultDonationUrl;
        _this.simpleMdPipe = new SimpleMdPipe();
        _this.course$ = _this.store.pipe(select(selectCurrentCourse), tap(function (c) {
            if (!c)
                return;
            if (_this.currentCourseId !== c.system_id) {
                // Update the page title to with the Course title
                // this.titleService.setTitle('Course - ' + this.simpleMdPipe.transform(c.title, 'plaintext') + ' | Hillsdale College Online Symposium');
                // this.meta.updateTag({ name: 'description', content: c.meta_description });
            }
            //set the current course caching ID
            _this.currentCourseId = c.system_id;
            // console.log('Course:', c);
            // if (c.lectures) {
            // 	this.runIntoIfNeeded();
            // }
        }));
        _this.currentLesson$ = _this.store.pipe(select(selectCurrentLesson), tap(function (l) {
            if (!l)
                return; //Should this be a filter?
            _this.currentLessonId = l.system_id;
            _this.currentLessonSlug = l.url_slug;
        }) //retrieve notes for current lesson
        );
        return _this;
    }
    Object.defineProperty(CourseComponent.prototype, "trailerVideoRef", {
        get: function () {
            return this.playerVideoRef;
        },
        set: function (value) {
            this.playerVideoRef = value;
        },
        enumerable: true,
        configurable: true
    });
    CourseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.tourIsOpen = localStorage && localStorage.getItem(tourKey) === curTourDate;
        // if we got the campaignId parameter, then get the details for that campaign
        this.route.params
            .pipe(map(function (p) { return ({ courseSlug: p.courseSlug, contentId: p.contentId }); }), filter(function (p) { return p.courseSlug; }))
            .subscribe(function (params) {
            _this.store.dispatch(setCurrentCourse({ currentCourse: params.courseSlug || '' }));
            if (params.contentId)
                _this.store.dispatch(setCurrentLesson({ currentLesson: params.contentId }));
        }, function (err) { return console.log('err', err); });
    };
    CourseComponent.prototype.ngOnDestroy = function () {
        this.store.dispatch(setCurrentCourse({ currentCourse: null }));
    };
    CourseComponent.prototype.trackLesson = function (index, item) {
        return item && item.system_id;
    };
    CourseComponent.prototype.runIntoIfNeeded = function () {
        if (!this.tourHasRun) {
            this.runIntro();
        }
    };
    CourseComponent.prototype.runIntro = function () {
        var _this = this;
        var runTour = function () {
            if (_this.tourIsOpen)
                return;
            _this.tourHasRun = true;
            _this.tourIsOpen = true;
            //TODO add types: https://github.com/usablica/intro.js/issues/701
            //delay the tour half a second to make sure everything loads
            setTimeout(function () {
                // tslint:disable-next-line:no-string-literal
                var intro = window['introJs']();
                intro.setOptions({
                    steps: [
                        {
                            intro: 'This is the course page, where all course materials are located. ' +
                                'Click next for navigation demo, or click skip to begin learning.'
                        },
                        {
                            element: document.querySelector('.course-card .card-header'),
                            intro: 'This is lecture 1. To open or close the lecture, click anywhere in this box.'
                        },
                        {
                            intro: 'Ready? Let\'s begin!'
                        }
                    ],
                    doneLabel: 'Finish Demo'
                });
                var completeTour = function () {
                    localStorage.setItem(tourKey, curTourDate);
                    _this.tourIsOpen = false;
                };
                //TODO while button is disabled, right arrow will still trigger next at the end of the list (throwing an error in the console)
                intro.onbeforechange(function (nextElem) {
                    // console.log('onbeforechange', nextElem);
                    if (nextElem && nextElem === document.getElementById('sidebar')) {
                        // console.log('about to sidebar');
                        //if we're about to open the sidebar intro, then scroll to the top
                        //if you don't scroll to the top, then the tooltip gets positioned off-screen (because of the styling of the sidebar)
                        window.scrollTo(0, 0);
                    }
                });
                intro.oncomplete(completeTour);
                intro.onexit(completeTour);
                intro.start();
            }, 500);
        };
        // tslint:disable-next-line:no-string-literal
        if (typeof window['introJs'] === 'undefined') {
            // const css = document.createElement('link');
            // css.rel = 'stylesheet';
            // css.type = 'text/css';
            // css.href = 'https://cdnjs.cloudflare.com/ajax/libs/intro.js/2.9.3/introjs.css';
            // document.head.appendChild(css);
            var script = document.createElement('script');
            script.src = 'https://cdnjs.cloudflare.com/ajax/libs/intro.js/2.9.3/intro.min.js';
            script.async = true;
            script.onload = runTour;
            document.head.appendChild(script);
        }
        else {
            runTour();
        }
    };
    CourseComponent.prototype.donateClicked = function ($event) {
        var donateUrl = $event.target && $event.target.href;
        this.store.dispatch(ui.donateClicked({ donateUrl: donateUrl }));
    };
    return CourseComponent;
}(VideoComponent));
export { CourseComponent };
